export const isBrowser = () => {
  return typeof XMLHttpRequest !== 'undefined';
};
export const isNode = () => {
  return typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]';
};
export const isFilePath = input => {
  return typeof input === 'string';
};
export const isFile = input => {
  return typeof input === 'object' && Object.prototype.toString.call(input) !== '[object Object]';
};
export const isDataURIScheme = input => {
  return typeof input === 'string' && input.startsWith('data:');
};